/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-01 11:04.
 */
const BaseComponent = require( 'base/category-page' );
const Server = require( 'helper/server' );
const Regexp = require( 'helper/regexp' );
const ImgUpload = require( 'helper/img-upload' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );

const staffListTpl = Handlebars.templates[ 'purchasing-federation/staff_info/templates/staff-list' ];
const staffOeratingTpl = Handlebars.templates[ 'purchasing-federation/staff_info/templates/staff-operating' ];

class StaffInfo extends BaseComponent {
  constructor() {
    super( {
      events: {
        'click .thumbnails': 'showBigImg',
        'click .add-staff': 'addStaff',
        'click .edit-staff': 'editStaff',
        'click .delete-staff': 'deleteStaff',
        'click .submit-staffInfo': 'submitStaffInfo',
        'change .upload-controller': 'uploadController',
        'click .delete-img': 'deleteImg'
      }
    } );
  }

  search() {
  }

  async init() {
    const data = initMenu( 'StaffInfo', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
    this.initPage();
  }

  async initPage() {
    try {
      const data = await Server.getStaffList();
      const staffList = staffListTpl( { _DATA_: data || {} } );
      this.$el.find( '.staff-list-table' ).html( staffList );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
  }

  showBigImg( e ) {
    const el = e.target || e.srcElement;
    const src = $( el ).attr( 'src' );
    const template = `
      <div class="modal-content">
        <img src="${ src }" alt="">
      </div> `;
    this.$el.find( '#show-big-img #modal-wrap' ).html( template );
    $( '#show-big-img' ).modal( 'show' );
  }

  renderStaffOperateModal( data ) {
    const html = staffOeratingTpl( { _DATA_: data } );
    this.$el.find( '#operate-modal #modal-wrap' ).html( html );
    const obj = {};
    if (data.headPhotoUrl) {
      obj.url = data.headPhotoUrl;
      obj.original = data.name;
    }
    const $form = this.$el.find( '#upload-form' );
    this.renderPaymentSnapshot( $form, obj, 'init' );
    $( '#operate-modal' ).modal( 'show' );
  }

  renderPaymentSnapshot( root, data, type ) {
    const $wrap = root.find( '.upload-certificate' );
    let html = '';
    if (_.isArray( data )) {
      $.map( data, ( item ) => {
        html += ImgUpload.genImg( item );
      } );
    } else {
      html = ImgUpload.genImg( data );
    }
    if (html) {
      if (type === 'upload') {
        $wrap.find( '.upload-certificate-upload  ' ).before( html );
      } else {
        $wrap.prepend( html );
      }
    }
    const $preview = $wrap.find( '.upload-certificate-preview' );
    if ($preview.length >= 1) {
      $wrap.find( '.upload-certificate-upload' ).hide();
    }
  }

  deleteImg( e ) {
    const $wrap = this.$el.find( '#upload-form' ).find( '.upload-certificate' );
    const el = e.target || e.srcElement;
    $( el ).parents( '.upload-certificate-preview' ).remove();
    const $preview = $wrap.find( '.upload-certificate-preview' );
    if ($preview.length === 0) {
      $wrap.find( '.upload-certificate-upload' ).show();
    }

  }

  submitStaffInfo( e ) {
    const el = e.target || e.srcElement;
    const $wrap = $( el ).parents( '.modal-content' ).find( '.form-root' );
    const id = $wrap.find( 'input[name="id"]' ).val().trim();
    const personType = $wrap.find( 'select[name="personType"]' ).val();
    const name = $wrap.find( 'input[name="name"]' ).val().trim();
    const job = $wrap.find( 'input[name="job"]' ).val().trim();
    const idNumber = $wrap.find( 'input[name="idNumber"]' ).val().trim();
    const mobile = $wrap.find( 'input[name="mobile"]' ).val().trim();
    const email = $wrap.find( 'input[name="email"]' ).val().trim();
    const $preview = $wrap.find( '.upload-certificate-preview' );
    const headPhotoUrl = $preview.length ? $preview.find( 'img' ).attr( 'src' ) : undefined;
    let errMsg;
    if (!( personType && name && idNumber && mobile && headPhotoUrl )) {
      errMsg = '有内容未填，请完善后再尝试提交！';
    }
    if (!Regexp.id.test( idNumber ) && !errMsg) {
      errMsg = '身份证输入不合法';
    }
    if (!Regexp.mobild.test( mobile ) && !errMsg) {
      errMsg = '请填写正确的手机号码';
    }
    if (job.length > 30 && !errMsg) {
      errMsg = '职务不得多于30个字符';
    }
    if (name.length > 30 && !errMsg) {
      errMsg = '姓名不得多于30个字符';
    }
    if (errMsg) {
      alert( errMsg );
      return false;
    }
    // else if (!Regexp.email.test( email )) {
    //   alert( '请填写正确的邮箱' );
    //   return false;
    // }
    const payload = {
      id,
      personType,
      name,
      job,
      idNumber,
      mobile,
      email,
      headPhotoUrl
    };
    Server.saveStaff( payload ).then( res => {
      const success = res === 1;
      if (res) {
        $( '#operate-modal' ).modal( 'hide' );
        ZCY.utils.modal( {
          type: 'success',
          cls: 'as-modal',
          button: [ '确定' ],
          content: [ `保存成功` ],
          container: $( '.purchasing-staff-info' ),
          confirm: ( $modal ) => {
            $modal.modal( 'hide' );
            this.initPage();
          }
        } );
      } else {
        alert( '保存失败' );
      }
    } );
  }

  deleteStaff( e ) {
    const el = e.target || e.srcElement;
    const personId = $( el ).data( 'id' );
    ZCY.utils.modal( {
      button: [ '确认', '取消' ],
      type: 'confirm',
      cls: 'as-modal',
      content: [ '删除后将无法恢复，您确定删除吗？' ],
      container: $( '.purchasing-staff-info' ),
      confirm( $modal ) {
        Server.deleteStaff( { personId } ).then( res => {
          const success = res === true;
          $modal.modal( 'hide' );
          ZCY.utils.modal( {
            type: success ? 'success' : 'error',
            button: [ '确定' ],
            cls: 'as-modal',
            content: [ `删除${ success ? '成功' : '失败' }` ]
          } );
          if (success) {
            $( el ).parents( 'tr' ).remove();
          }
        } );
      }
    } );
  }

  addStaff() {
    this.renderStaffOperateModal( {
      title: '新增员工',
      modalType: 'add'
    } );
  }

  editStaff( e ) {
    const el = e.target || e.srcElement;
    const metadata = $( el ).parents( 'tr' ).find( '.metadata' ).val() || '{}';
    const data = JSON.parse( metadata );
    this.renderStaffOperateModal( {
      ...data,
      title: '编辑员工',
      modalType: 'edit'
    } );
  }

  uploadController( e ) {
    const $form = this.$el.find( '#upload-form' );
    const { size, name } = ImgUpload.getFileSize( e );
    if (size > 5) {
      alert( '附件过大，无法上传成功, 请重新上传' );
      $form[ 0 ].reset();
      return false;
    }
    const fileName = name.substr( name.lastIndexOf( '.' ) ).toUpperCase();
    if (fileName !== '.PNG' && fileName != '.JPG' && fileName !== '.JPEG') {
      alert( '图片限于png,jpeg,jpg格式' );
      $form[ 0 ].reset();
      return false;
    }
    $form.ajaxSubmit( {
      type: 'post',
      url: Server.urls.upload,
      contentType: 'application/json',
      dataType: 'json',
      iframeTarget: '#myFrame',
      success: ( data ) => {
        $form[ 0 ].reset();
        this.renderPaymentSnapshot( $form, data, 'upload' );
      },
      error: ( msg ) => {
        $form[ 0 ].reset();
        alert( msg.responseText || '未知错误' );
      }
    } );
  }
}

module.exports = StaffInfo;
